import React from "react";
import { MAX_VIDEO_TAG_LENGTH } from "../../modals/trainingTagsModal/containers/modalBody/controller";

const holder = {
  closeDropdownSelector(e) {
    if (
      holder.containerRef &&
      !holder.containerRef.current?.contains(e.target)
    ) {
      holder.outlet({
        buttonAction: "handle_open_state",
        isOpen: false,
      });
      holder.internalStateSetter({ isOpen: false, searchTerm: "" });
      document.removeEventListener("mousedown", holder.closeDropdownSelector);
    }
  },
};

export default {
  refreshOn: ({ isOpen }) => [isOpen],
  init: async (
    { isOpen, inputRef },
  ) => {
    if (isOpen) {
      inputRef?.current?.children?.[0]?.focus();
      document.removeEventListener("mousedown", holder.closeDropdownSelector);
      document.addEventListener("mousedown", holder.closeDropdownSelector);
    }
  },
  "Dropdown.Selector": async (
    { isOpen, containerRef, inputRef, disabled },
    outlet,
    internalStateSetter
  ) => {
    if (disabled) return;
    let newInputRef = inputRef;
    let newContainerRef = containerRef;

    if (!inputRef || !containerRef) {
      newInputRef = React.createRef();
      newContainerRef = React.createRef();

      await internalStateSetter({ inputRef: newInputRef, containerRef: newContainerRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    holder.outlet = outlet;
    outlet({
      buttonAction: "handle_open_state",
      isOpen: !isOpen,
    });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDropdownSelector);
    } else {
      inputRef?.current?.children?.[0]?.focus();
      document.addEventListener("mousedown", holder.closeDropdownSelector);
    }
  },
  "Dropdown.Selector.ButtonsWrapper.AddButtonWrapper.AddNew": (
    { action, searchTerm },
    outlet,
    internalStateSetter
  ) => {
    if(action === "add_new_tag" && searchTerm?.length <= MAX_VIDEO_TAG_LENGTH) {
      internalStateSetter({ searchTerm: "" })
    }
    outlet({ buttonAction: action, value: searchTerm });
  },
  "Dropdown.Selector.LeftSide.Wrapper.SearchInput": (
    { value },
    _,
    internalStateSetter
  ) => {
    internalStateSetter({ searchTerm: value, isOpen: true });
  },
  "Dropdown.Selector.LeftSide.Wrapper.SearchInput(Keydown)": () => {},
  "Dropdown.Selector.LeftSide.Wrapper.SelectedButton": (
    { selectedOptionId, selectedOptionIds },
    outlet
  ) => {
    outlet({
      buttonAction: "tag-removed",
      currentSelectedIds: selectedOptionIds.filter(
        (id) => id !== selectedOptionId
      ),
    });
  },
  "Dropdown.Body.Option": (
    { option, selectedOptionIds, multipleSelect, inputRef },
    outlet,
    internalStateSetter
  ) => {
    if (multipleSelect) {
      if (selectedOptionIds.includes(option.id)) {
        outlet({
          selectedOptionIds: selectedOptionIds.filter((id) => id !== option.id),
        });
      } else {
        outlet({ selectedOptionIds: [...selectedOptionIds, option.id] });
      }
      inputRef?.current?.children?.[selectedOptionIds.length]?.focus();
      internalStateSetter("isOpen", false);
    } else {
      outlet({
        selectedOptionIds:
          option.id === selectedOptionIds[0] ? [] : [option.id],
      });
      internalStateSetter("isOpen", false);
    }
    internalStateSetter({ searchTerm: "" });
  },
  "Dropdown.Body.TagsWrapper.TagRow": (
    { action, tag, selectedOption },
    outlet
  ) => {
    outlet({
      selectedOption: action === "save" ? selectedOption : tag,
      buttonAction: action,
    });
  },
};
